var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 614.3 233.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:7px;letter-spacing:0.05em;}.cls-1,.cls-2,.cls-5,.cls-6{fill:#fff;}.cls-1,.cls-2{font-family:ArialMT, Arial;}.cls-11,.cls-2,.cls-7{font-size:10px;}.cls-2{letter-spacing:0.05em;}.cls-3,.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-4{stroke-width:0.35px;}.cls-5{fill-rule:evenodd;}.cls-11,.cls-7{fill:#ed1c24;font-family:Arial-BoldMT, Arial;font-weight:700;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:0.02em;}.cls-9{letter-spacing:-0.05em;}.cls-10,.cls-11{letter-spacing:0.02em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diagram"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(21.23 150.28)"
  }, "P1"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(92.97 150.28)"
  }, "P2"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(161.25 150.28)"
  }, "P3"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(424.42 229.97)"
  }, "[NFT]"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.94 229.97)"
  }, "[ BLOCK HOLDERS ]"), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.96 104.61 40.96 81.46 20.91 69.89 0.87 81.46 0.87 104.61 20.91 116.18 40.96 104.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 0.87,
    y1: 81.46,
    x2: 20.91,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 40.96,
    y1: 81.46,
    x2: 20.91,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.91,
    y1: 116.18,
    x2: 20.91,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.96 104.61 40.96 81.46 20.91 69.89 0.87 81.46 0.87 104.61 20.91 116.18 40.96 104.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "111.05 104.61 111.05 81.46 91.01 69.89 70.97 81.46 70.97 104.61 91.01 116.18 111.05 104.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.97,
    y1: 81.46,
    x2: 91.01,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 111.05,
    y1: 81.46,
    x2: 91.01,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.01,
    y1: 116.18,
    x2: 91.01,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "111.05 104.61 111.05 81.46 91.01 69.89 70.97 81.46 70.97 104.61 91.01 116.18 111.05 104.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "181.08 104.61 181.08 81.46 161.04 69.89 141 81.46 141 104.61 161.04 116.18 181.08 104.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 141,
    y1: 81.46,
    x2: 161.04,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 181.08,
    y1: 81.46,
    x2: 161.04,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 161.04,
    y1: 116.18,
    x2: 161.04,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "181.08 104.61 181.08 81.46 161.04 69.89 141 81.46 141 104.61 161.04 116.18 181.08 104.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.3,136.55v14.3H0v-14.3ZM10.06,149.8h3.19V139.35H1.05V149.8H4.24m1.17-3.54H8.9v1.05H5.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 4.24,
    cy: 142.44,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 10.24,
    cy: 142.44,
    r: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 5.41,
    y: 146.26,
    width: 3.49,
    height: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.76,136.55v14.3H71.45v-14.3ZM81.52,149.8H84.7V139.35H72.51V149.8H75.7m1.16-3.54h3.49v1.05H76.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 75.7,
    cy: 142.44,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 81.7,
    cy: 142.44,
    r: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 76.86,
    y: 146.26,
    width: 3.49,
    height: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154,136.55v14.3h-14.3v-14.3ZM149.8,149.8H153V139.35H140.8V149.8H144m1.17-3.54h3.49v1.05h-3.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 143.98,
    cy: 142.44,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 149.98,
    cy: 142.44,
    r: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 145.15,
    y: 146.26,
    width: 3.49,
    height: 1.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "454.98 58.36 454.98 35.25 454.98 12.13 434.97 0.58 414.95 12.13 414.95 35.25 414.95 58.36 394.93 46.81 374.91 35.25 354.9 46.81 354.9 69.92 374.91 81.48 394.93 93.03 374.91 104.59 354.9 116.15 354.9 139.26 374.91 150.82 394.93 139.26 414.95 127.7 414.95 150.82 414.95 173.93 434.97 185.49 454.98 173.93 454.98 150.82 454.98 127.7 475 139.26 495.02 150.82 515.04 139.26 515.04 116.15 495.02 104.59 475 93.03 495.02 81.48 515.04 69.92 515.04 46.81 495.02 35.25 475 46.81 454.98 58.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 46.81,
    x2: 454.98,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 58.36,
    x2: 475,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 69.92,
    x2: 495.02,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 93.03,
    x2: 495.02,
    y2: 81.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 58.36,
    x2: 475,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 104.59,
    x2: 394.93,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 116.15,
    x2: 414.95,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 127.71,
    x2: 414.95,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 139.26,
    x2: 414.95,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 93.03,
    x2: 374.91,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 185.49,
    x2: 414.95,
    y2: 173.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 173.93,
    x2: 434.97,
    y2: 185.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 162.38,
    x2: 434.97,
    y2: 185.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 150.82,
    x2: 454.98,
    y2: 173.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 150.82,
    x2: 414.95,
    y2: 173.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 93.03,
    x2: 454.98,
    y2: 81.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 116.15,
    x2: 434.97,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 93.03,
    x2: 454.98,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 116.15,
    x2: 454.98,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 162.38,
    x2: 414.95,
    y2: 150.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 150.82,
    x2: 434.97,
    y2: 162.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 139.26,
    x2: 434.97,
    y2: 162.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 127.71,
    x2: 454.98,
    y2: 150.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 127.71,
    x2: 414.95,
    y2: 150.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 0.58,
    x2: 414.95,
    y2: 12.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 12.13,
    x2: 434.97,
    y2: 0.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 23.69,
    x2: 454.98,
    y2: 12.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 35.25,
    x2: 454.98,
    y2: 12.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 46.81,
    x2: 454.98,
    y2: 35.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 35.25,
    x2: 414.95,
    y2: 12.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 12.13,
    x2: 434.97,
    y2: 23.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 46.81,
    x2: 434.97,
    y2: 23.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 515.04,
    y1: 46.81,
    x2: 495.02,
    y2: 35.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 58.36,
    x2: 515.04,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 515.04,
    y1: 69.92,
    x2: 515.04,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 81.48,
    x2: 515.04,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 81.48,
    x2: 495.02,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 35.25,
    x2: 475,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 116.15,
    x2: 495.02,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 139.26,
    x2: 495.02,
    y2: 150.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 104.59,
    x2: 475,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 139.26,
    x2: 475,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 515.04,
    y1: 116.15,
    x2: 495.02,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 150.82,
    x2: 495.02,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 127.71,
    x2: 515.04,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 515.04,
    y1: 139.26,
    x2: 515.04,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 150.82,
    x2: 515.04,
    y2: 139.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 81.48,
    x2: 475,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 93.03,
    x2: 475,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 104.59,
    x2: 434.97,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 127.71,
    x2: 434.97,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 81.48,
    x2: 394.93,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 58.36,
    x2: 394.93,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 81.48,
    x2: 374.91,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 58.36,
    x2: 394.93,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 81.48,
    x2: 394.93,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 58.36,
    x2: 454.98,
    y2: 35.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 69.92,
    x2: 454.98,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 58.36,
    x2: 414.95,
    y2: 35.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 35.25,
    x2: 434.97,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 69.92,
    x2: 434.97,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 58.36,
    x2: 434.97,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 104.59,
    x2: 354.9,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 116.15,
    x2: 374.91,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 127.71,
    x2: 394.93,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 139.26,
    x2: 394.93,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 150.82,
    x2: 394.93,
    y2: 139.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 354.9,
    y1: 139.26,
    x2: 354.9,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 354.9,
    y1: 116.15,
    x2: 374.91,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 150.82,
    x2: 374.91,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 354.9,
    y1: 139.26,
    x2: 374.91,
    y2: 150.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 354.9,
    y1: 46.81,
    x2: 374.91,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 354.9,
    y1: 69.92,
    x2: 374.91,
    y2: 81.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 35.25,
    x2: 354.9,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 354.9,
    y1: 69.92,
    x2: 354.9,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 46.81,
    x2: 374.91,
    y2: 35.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 374.91,
    y1: 58.36,
    x2: 394.93,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 81.48,
    x2: 454.98,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 93.03,
    x2: 454.98,
    y2: 81.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 81.48,
    x2: 414.95,
    y2: 58.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 93.03,
    x2: 434.97,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 81.48,
    x2: 434.97,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 139.26,
    x2: 414.95,
    y2: 127.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 127.71,
    x2: 434.97,
    y2: 139.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 434.97,
    y1: 116.15,
    x2: 434.97,
    y2: 139.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475,
    y1: 93.03,
    x2: 454.98,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 495.02,
    y1: 104.59,
    x2: 475,
    y2: 93.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 127.71,
    x2: 454.98,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 104.59,
    x2: 475,
    y2: 116.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 454.98,
    y1: 127.71,
    x2: 475,
    y2: 139.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 414.95,
    y1: 58.36,
    x2: 394.93,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 93.03,
    x2: 394.93,
    y2: 69.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394.93,
    y1: 69.92,
    x2: 414.95,
    y2: 81.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 539.06,
    y: 86.87,
    width: 75.24,
    height: 20.52,
    rx: 8.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30.6,
    y: 51.89,
    width: 20.63,
    height: 20.52,
    rx: 8.42
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(549.66 100.33)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 6.13,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 14.11,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 19.67,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.09,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 33.22,
    y: 0,
    xmlSpace: "preserve"
  }, " : 19")), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(38.34 65.35)"
  }, "3"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.7,
    y: 51.89,
    width: 20.63,
    height: 20.52,
    rx: 8.42
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(108.44 65.35)"
  }, "7"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 170.73,
    y: 51.89,
    width: 20.63,
    height: 20.52,
    rx: 8.42
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(178.47 65.35)"
  }, "9"), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.43,91.15a66.6,66.6,0,0,0-16.84-8.69,74.63,74.63,0,0,0-9.1-2.57,41.67,41.67,0,0,0-9.31-.87,44.48,44.48,0,0,0-18.1,4.54,68.39,68.39,0,0,0-8.24,4.75c-1.33.87-2.63,1.79-3.93,2.73a24.17,24.17,0,0,1-4,2.63,10.93,10.93,0,0,0,1.9-1.44l1.81-1.57c1.21-1.06,2.44-2.1,3.71-3.09a56.3,56.3,0,0,1,8.09-5.34,42,42,0,0,1,18.73-5.18,40,40,0,0,1,9.76.94,65,65,0,0,1,9.31,2.84,56.85,56.85,0,0,1,16.65,9.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.83 86.26 315.93 95.73 306.17 93.68 312.83 86.26"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.ccd3cec08fc3c1238d2c14b58459765d.svg";
export { ForwardRef as ReactComponent };